__turbopack_context__.v({
  "boxContentElement": "Contents-module__4JlCXW__boxContentElement",
  "boxContentElementWrapper": "Contents-module__4JlCXW__boxContentElementWrapper",
  "contentsList": "Contents-module__4JlCXW__contentsList",
  "root": "Contents-module__4JlCXW__root",
  "title": "Contents-module__4JlCXW__title",
  "wrapper": "Contents-module__4JlCXW__wrapper",
});
